export const COURIER_AVAILABILITY = {
  ONLINE: 'online',
  OFFLINE: 'offline',
}

export function isValidCourierAvailability(status) {
  return (
    status === COURIER_AVAILABILITY.ONLINE || status === COURIER_AVAILABILITY.OFFLINE
  )
}
